import React from "react";
import GaugeElement from "./gauge-element";
import useIpcLocalisationData from "../../../../hooks/use-ipc-localisation-data.ts";
import SimpleLoadingIndicator from "../../../../components/simple-loading-indicator";

type GaugesLayoutProps = {
    localisationId: number;
    className?: string;
}

const GaugesLayout: React.FC<GaugesLayoutProps> = (
    {localisationId, className = ''},
) => {
    const {data, isLoading, error} = useIpcLocalisationData(localisationId);
    
    if(isLoading) 
        return (
            <div className='h-50 w-full flex'>
                <SimpleLoadingIndicator/>
            </div>
        )
    
    if(error) return (
        <div>Error...</div>
    )
    
    if(data == null || data.calculations.length === 0) return (
        <div>No data</div>
    )
    
    return (
        <div className={className}>
            {data.calculations.map((ipc) => (
                <GaugeElement key={ipc.keyName} ipc={ipc} />
            ))}
        </div>
    )
}

export default GaugesLayout;